import CKNavigator from "../lib/CKNavigator";
import PublicBase from "../lib/PublicBase";
import CommsLayer from "../lib/api/CommsLayer";
import ShadowPanel from "../lib/components/ShadowPanel";
import View from "../lib/components/View";
import { useParams, useSearchParams } from "react-router-dom";
import LoggedInBase from "./LoggedInBase";
import CKSpacer from "../lib/components/CKSpacer";
import {ReactComponent as NotFound} from '../images/not_found.svg';
import moment from "moment";
import sanitizeHtml from "sanitize-html";
import CKButton from "../lib/components/CKButton";
import Alert from "../lib/components/Alert";
import Cookies from 'js-cookie';

const SCREEN_TO_SHOW = {
    LOADING: 'loading',
    NOT_FOUND: 'notFound',
    EXPIRED: 'expired',
    JOINED: 'joined',
    NOT_JOINED: 'not-joined',
    NOT_STARTED: 'notStarted'
}

// storing cookie value for page refresh, to avoid redirection on first load
const COOKIE_TOKEN_PREVIOIUS = 'previous-competition-token';

class Competition extends LoggedInBase {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            loading: true,
            loadingText: 'Loading...',
            screenToShow: SCREEN_TO_SHOW.LOADING,
            isJoiningInProgress: false
        }

        this.redirectTo = CKNavigator.competition.replace(':id', this.props.params.id);
    }

    getPreviousTokenAuth = () => {
        let previesToken = Cookies.get(COOKIE_TOKEN_PREVIOIUS);

        if(previesToken) return previesToken;

        return false;
    }

    setPreviousTokenAuth = (token) => {
        let previesToken = Cookies.set(COOKIE_TOKEN_PREVIOIUS, CommsLayer.IS_SECURE ? { sameSite: 'none', secure: true} : {});

        if(previesToken) return previesToken;

        return false;
    }

    componentDidMount() {
        // first verify if token is received
        if (this.props.searchParams && this.props.searchParams.get('token') && this.props.searchParams.get('token') != this.getPreviousTokenAuth()) {
            this.showLoading();

            let token = this.props.searchParams.get('token');

            CommsLayer.loginToken(token).then((result) => {
                CommsLayer.members().membersV1GetMemberInfo().then(async resp => {
                    let cardsInfo = await CommsLayer.members().membersV1GetMemberSummary();
                    
                    if(cardsInfo) {
                        CommsLayer.cardInfo = cardsInfo;
                    }

                    this.setPreviousTokenAuth(token);

                    // Avoid changing location, this affects iOS build
                    // redirect user to same page but with no token
                    // window.location.href = this.redirectTo;

                    // proceed to normal initialization flow
                    super.componentDidMount();

                    this.hideLoading();
                }).catch(() => {
                    (async () => {
                        await CommsLayer.logout();
                        this.navigateTo('/login');
                    })();
                });
            }).catch(err => {
                (async () => {
                    await CommsLayer.logout();
                    this.navigateTo('/login');
                })();
            })

        } else {
            super.componentDidMount();
        }
    }

    showScreen = (screen, competition = false) => {
        this.setState({
            screenToShow: screen,
            competition: competition
        }, () => {
            this.hideLoading();
        });
    }

    loadData = () => {
        // lets load new competitions.xml and see if competitionId exists
        CommsLayer.xmls().competitions().then(async competitions => {
            // lets go through every competition and make sure that given ID exists
            if(competitions && competitions.length) {
                let competition = competitions.find(c => {
                    return c.key == this.props.params.id
                });

                if(competition) {
                    // lets check if expired or accessed before time
                    let startDay = moment(competition.start_day);
                    let endDay = moment(competition.end_day);

                    if(startDay.isAfter(moment())) {
                        this.showScreen(SCREEN_TO_SHOW.NOT_STARTED, competition);
                    } else if(endDay.isBefore(moment())) {
                        this.showScreen(SCREEN_TO_SHOW.EXPIRED, competition);
                    } else {
                        // determine if user is in the competition group
                        let isInGroup = false;

                        try {
                            // need to check all my groups and see if I am in the group of the XML
                            let clubsData = await CommsLayer.clubs().get();
                            if(clubsData && clubsData.clubs && clubsData.clubs.length > 0) {
                                isInGroup = clubsData.clubs.find(f => {
                                    return f.ClubId == competition.groupid;
                                }) ? true : false;
                            }
                        } catch (e) {
                            console.log(e);
                        }

                        if(isInGroup) {
                            this.showScreen(SCREEN_TO_SHOW.JOINED, competition);
                        } else {
                            this.showScreen(SCREEN_TO_SHOW.NOT_JOINED, competition);
                        }
                    }
                } else {
                    this.showScreen(SCREEN_TO_SHOW.NOT_FOUND);
                }
            } else {
                this.showScreen(SCREEN_TO_SHOW.NOT_FOUND);
            }
        }).catch(err => {
            // display error = not found
            this.showScreen(SCREEN_TO_SHOW.NOT_FOUND);
        })
    }

    joinCompetition = () => {
        let unableToJoinAlert = (title = '', message = '') => {
            this.setState({
                isJoiningInProgress: false
            }, () => {
                Alert.alert(title ? title : 'Unable to join', message ? message :'Unable to join at this time. Please try again later.');
            });
        }

        this.setState({
            isJoiningInProgress: true
        }, async () => {
            try {
                let response = await CommsLayer.clubs().clubsV1AddMemberToClub(this.state.competition.groupid);

                if(response.Success) {
                    this.setState({
                        isJoiningInProgress: false,
                        screenToShow: SCREEN_TO_SHOW.JOINED
                    })
                } else {
                    unableToJoinAlert();
                }
            } catch(e) {
                unableToJoinAlert();
            }
        })
    }

    render() {
        return super.render(        
            <View className="competition-container">
                {this.state.screenToShow == SCREEN_TO_SHOW.NOT_FOUND ? <View className="not_found">
                    <NotFound />
                    <h2>Page not found</h2>
                    <p>The page you are looking for doesn't exist</p>
                </View> : null}

                {[SCREEN_TO_SHOW.EXPIRED, SCREEN_TO_SHOW.NOT_STARTED, SCREEN_TO_SHOW.JOINED, SCREEN_TO_SHOW.NOT_JOINED].indexOf(this.state.screenToShow) >= 0 ?
                    <View className="competition-overall-container">
                        <View className="competition">
                            <View className="banner">
                                <img src={this.state.competition.img} alt={this.state.competition.title} />
                            </View>


                            <View className="competition-content">
                                {[SCREEN_TO_SHOW.EXPIRED, SCREEN_TO_SHOW.NOT_STARTED].indexOf(this.state.screenToShow) >= 0 ? <p className={"tag " + (this.state.screenToShow == SCREEN_TO_SHOW.EXPIRED ? 'ended' : '')}>
                                        {this.state.screenToShow == SCREEN_TO_SHOW.NOT_STARTED ? (
                                            this.state.competition.action && this.state.competition.action.not_started ?
                                            this.state.competition.action.not_started
                                            :
                                            'Competition not started'
                                        ) : (
                                            this.state.competition.action && this.state.competition.action.ended ?
                                            this.state.competition.action.ended
                                            :
                                            'Competition ended'
                                        )}
                                    </p>
                                    :
                                    null
                                }
                                <h1>{this.state.competition.title}</h1>

                                <View dangerouslySetInnerHTML={{__html: sanitizeHtml(this.state.competition.description)}}></View>
                            </View>
                        </View>

                        {[SCREEN_TO_SHOW.JOINED, SCREEN_TO_SHOW.NOT_JOINED].indexOf(this.state.screenToShow) >= 0 ? <View className="competition-button-container">
                                <CKButton
                                    disabled={this.state.screenToShow == SCREEN_TO_SHOW.JOINED}
                                    loading={this.state.isJoiningInProgress}
                                    onClick={this.joinCompetition}>
                                        {this.state.screenToShow == SCREEN_TO_SHOW.JOINED ? (
                                            this.state.competition.action && this.state.competition.action.joined ? 
                                            this.state.competition.action.joined
                                            :
                                            'Competition joined'
                                        ) : (
                                            this.state.competition.action && this.state.competition.action.join ?
                                            this.state.competition.action.join
                                            :
                                            'Join competition'
                                        )}
                                    </CKButton>
                            </View>
                            :
                            null
                        }

                        <CKSpacer />
                        <CKSpacer />
                        <CKSpacer />
                    </View>
                :
                null}
            </View>
        )
    }
}

export default (props) => {
    const [searchParams] = useSearchParams();
    return <Competition
        {...props}
        params={useParams()}
        searchParams={searchParams}
    />
};